let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iUYKa")).then(() => parcelRequire('aEeJp'));